var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    clipPath: "url(#clip0_1223_2923)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ELEMENTS",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.89035 6.71013L9.21402 4.65366H7.22023V3.31696C7.22023 2.75464 7.49858 2.20518 8.38867 2.20518H9.30788V0.453965C8.77258 0.368603 8.23167 0.322422 7.68955 0.315796C6.04855 0.315796 4.97721 1.30226 4.97721 3.0856V4.65366H3.1582V6.71013H4.97721V11.6842H7.22023V6.71013H8.89035Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.89035 6.71013L9.21402 4.65366H7.22023V3.31696C7.22023 2.75464 7.49858 2.20518 8.38867 2.20518H9.30788V0.453965C8.77258 0.368603 8.23167 0.322422 7.68955 0.315796C6.04855 0.315796 4.97721 1.30226 4.97721 3.0856V4.65366H3.1582V6.71013H4.97721V11.6842H7.22023V6.71013H8.89035Z",
    fill: "#202020"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1223_2923"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.3684,
    height: 11.3684,
    fill: "white",
    transform: "translate(0.315918 0.315796)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.14063d297a133acd3cebf0b261260f28.svg";
export { ForwardRef as ReactComponent };